module.exports = __webpack_public_path__ + "static/media/Tourproviders.d42296a7.png";